'use strict';

/**
 * Initializes or destroys the Slick carousel on `.product-media` elements
 * based on viewport width and item count.
 *
 * - On screens ≤ 1024px and when there are at least 2 `.product-media-items`,
 *   Slick is initialized if not already active.
 * - On screens > 1024px or when fewer than 2 items exist,
 *   any active Slick instance is destroyed.
 *
 * @function initOrDestroySlick
 * @returns {void} This function does not return a value.
 */
function initOrDestroySlick() {
    $('.product-media').each(function () {
        var itemCount = $(this).find('.product-media-items').length;
        if ($(window).width() < 1024 && itemCount >= 2) {
            if (!$(this).hasClass('slick-initialized')) {
                $(this).slick({
                    arrows: true,
                    dots: true,
                    infinite: false,
                    slidesToShow: 1
                });
            }
        } else if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }
        $(this).removeClass('mobile-hidden');
    });
}

initOrDestroySlick();

$(window).on('resize', function () {
    initOrDestroySlick();
});

var iframe = document.getElementById('castrVideo');

if (iframe) {
    var iframeUrl = iframe.src;

    // Observe visibility of the iframe
    let observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            let $element = $(entry.target);
            if ($element.length) {
                if (entry.isIntersecting) {
                    iframe.src = iframeUrl;
                } else {
                    iframe.src = iframeUrl + '?autoplay=off';
                }
            }
        });
    }, { threshold: 0.5 });

    observer.observe(iframe);
}

// Zoom config
var lensFactor = 0.3486;

/**
 * Enables a zoom effect on an image using a lens overlay and a result container.
 *
 * @param {jQuery|HTMLElement} imgElement - Image element with `hi-res-url` attribute.
 * @param {string} resultID - ID of the zoom result container.
 *
 * @description
 * Tracks mouse movement, positions the lens, and updates the zoomed background
 * inside the result container. Scales responsively with window width.
 */
function imageZoom(imgElement, resultID) {
    var img = imgElement;
    var imgWidth = img.outerWidth();
    var imgHeight = img.outerHeight();
    var result = $('#' + resultID);
    var lens = img.closest('.product-media-items').find('.img-zoom-lens');

    lens.removeClass('d-none').css({
        width: (imgWidth * lensFactor) + 'px',
        height: (imgHeight * lensFactor) + 'px'
    });

    const baseScreenWidth = 1440;
    const baseResultWidth = 651; // original design reference
    const baseResultHeight = 687; // original design reference

    // maximum allowed size for the zoom result (keeps it small on large screens)
    const maxResultWidth = 480; // px
    const maxResultHeight = 480; // px

    let scale = $(window).width() / baseScreenWidth;
    let resultWidth = Math.min(baseResultWidth * scale, maxResultWidth);
    let resultHeight = Math.min(baseResultHeight * scale, maxResultHeight);

    var cx = resultWidth / lens.width();
    var cy = resultHeight / lens.height();

    result.css({
        backgroundImage: "url('" + img.attr('hi-res-url') + "')",
        backgroundSize: (imgWidth * cx) + 'px ' + (imgHeight * cy) + 'px',
        backgroundRepeat: 'no-repeat',
        boxSizing: 'border-box'
    });

    /**
     * Gets the cursor position relative to the image element.
     *
     * @param {MouseEvent} e - The mouse event.
     * @returns {{x: number, y: number}} Coordinates relative to the top-left corner of the image.
     */
    function getCursorPos(e) {
        var offset = img.offset();
        return {
            x: e.pageX - offset.left,
            y: e.pageY - offset.top
        };
    }

    /**
     * Moves the zoom lens based on cursor position and updates the zoom result.
     *
     * @param {MouseEvent} e - The mouse move event.
     * @description
     * - Centers the lens on the cursor.
     * - Constrains the lens inside image bounds.
     * - Updates lens position and zoomed background position in the result container.
     */
    function moveLens(e) {
        e.preventDefault();
        var pos = getCursorPos(e);
        var x = pos.x - lens.width() / 2;
        var y = pos.y - lens.height() / 2;

        if (x > imgWidth - lens.width()) x = imgWidth - lens.width();
        if (x < 0) x = 0;
        if (y > imgHeight - lens.height()) y = imgHeight - lens.height();
        if (y < 0) y = 0;

        lens.css({ left: x + 'px', top: y + 'px' });

        // Compute background positions and clamp so we never show empty space
        var bgPosX = -x * cx;
        var bgPosY = -y * cy;

        // Maximum negative offsets (when the background is shifted fully to the left/top)
        var maxNegX = -(imgWidth * cx - resultWidth);
        var maxNegY = -(imgHeight * cy - resultHeight);

        // Clamp background position
        if (bgPosX < maxNegX) bgPosX = maxNegX;
        if (bgPosX > 0) bgPosX = 0;
        if (bgPosY < maxNegY) bgPosY = maxNegY;
        if (bgPosY > 0) bgPosY = 0;

        result.css({
            width: resultWidth + 'px',
            height: resultHeight + 'px',
            backgroundPosition: bgPosX + 'px ' + bgPosY + 'px'
        });
    }

    img.closest('.product-media-items').on('mousemove.zoom', moveLens);
}

let zoomActive = false;

/**
 * Disables zoom functionality on product images.
 * - Hides zoom-related UI elements
 * - Removes zoom styles and event listeners
 */
window.disableZoomDeskProductImage = function () {
    zoomActive = false;

    $('.enable-zoom').removeClass('d-lg-block');
    $('.disable-zoom').addClass('d-none');
    $('#hover-result-container').addClass('d-none');

    $('.img-zoom-lens').addClass('d-none').removeAttr('style');
    $('.media-img').removeClass('imgid-overopacity').off('mousemove.zoom');
};

/**
 * Checks whether the current PDP is a DiamondOnCall (DOC) PDP
 * by testing for the `.doc-pdp` marker class on `.product-media`.
 *
 * @returns {boolean} True when the page is a DOC PDP.
 */
function isDocPdp() {
    return $('.product-media').hasClass('doc-pdp');
}

$(window).on('resize load', function () {
    if ($(window).width() >= 1024) {
        $('.product-media').on('mouseenter', '.product-media-items img', function () {
            if (!zoomActive) {
                $(this).closest('.product-media-items').find('.enable-zoom').addClass('d-lg-block');
            } else {
                $('.stone-fact-desktop').addClass('d-none');
            }
        });

        $('.product-media').on('mouseleave', '.product-media-items', function () {
            if (!zoomActive) {
                $(this).find('.enable-zoom').removeClass('d-lg-block');
            } else {
                $(this).find('.img-zoom-lens').addClass('d-none');
                $('#hover-result-container').addClass('d-none');
            }
        });

        $('.product-media').on('click', '.enable-zoom', function () {
            zoomActive = true;

            $('.enable-zoom').removeClass('d-lg-block');
            $('.disable-zoom').removeClass('d-none');
        });

        $('.product-media').on('mouseenter', '.media-img', function () {
            if (!zoomActive) return;

            $('.img-zoom-lens').addClass('d-none').removeAttr('style');
            $('.media-img').removeClass('imgid-overopacity').off('mousemove.zoom');
            $('#hover-result-container').removeClass('d-none');

            const $img = $(this);
            $img.addClass('imgid-overopacity');
            imageZoom($img, 'hover-result');
        });

        $('.product-media').on('click', '.disable-zoom', function () {
            window.disableZoomDeskProductImage();
        });

        $('.product-media').on('mouseleave', function () {
            if (zoomActive) {
                window.disableZoomDeskProductImage();
            }
        });

        if ($('#mob-product-zoom-popup').hasClass('show')) {
            $('#mob-product-zoom-popup').modal('hide');
        }
        $('#mob-product-zoom-popup').removeClass('modal').addClass('d-none');
    } else {
        $('.product-media .media-img').off('mouseenter mouseleave mousemove.zoom');
        $('#hover-result-container').addClass('d-none');
        $('div.img-zoom-lens').addClass('d-none').removeAttr('style');
        $('.media-img').removeClass('imgid-overopacity');

        $('#mob-product-zoom-popup').addClass('modal').removeClass('d-none');

        $('.product-media').on('click', '.product-media-items', function () {
            if ($('#mob-product-zoom-popup').hasClass('modal')) {
                $('#mob-product-zoom-popup').modal('show');
            }
        });

        $('.thumb-scroll-horizontal .slide-trigger').each(function (i) {
            $(this).attr('data-index', i);
        });

        var Swiper = require('../thirdParty/swiper');

        var swiperModal = new Swiper('.image-slider', {
            spaceBetween: 12,
            zoom: {
                enabled: true,
                maxRatio: 2,
                minRatio: 1
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });

        swiperModal.on('slideChange', function () {
            var index = this.activeIndex; // current active slide index
            $('.thumb-scroll-horizontal .slide-trigger').removeClass('active').eq(index).addClass('active');
            if (!$('.zoom-out-icon').hasClass('d-none')) {
                $('.zoom-icon, .zoom-out-icon').toggleClass('d-none');
            }
        });

        swiperModal.on('zoomChange', function (swiper, scale) {
            if (scale > 1) {
                $('.zoom-icon').addClass('d-none');
                $('.zoom-out-icon').removeClass('d-none');
            } else {
                $('.zoom-icon').removeClass('d-none');
                $('.zoom-out-icon').addClass('d-none');
            }
        });

        // zoom in
        $('.zoom-icon').on('click', function () {
            swiperModal.zoom.in();
        });

        // zoom out (reset to normal)
        $('.zoom-out-icon').on('click', function () {
            swiperModal.zoom.out();
        });

        $('.thumb-scroll-horizontal .slide-trigger').on('click', function () {
            var index = $(this).data('index');
            swiperModal.slideTo(index);
        });

        $('.product-media').on('afterChange', function (event, slick, currentSlide) {
            if (isDocPdp()) {
                return;
            }

            swiperModal.slideTo(currentSlide);
        });
    }

    $('body').on('hide.bs.modal', '#mob-product-zoom-popup', function () {
        $('.zoom-out-icon').trigger('click');
    });
});

$('#pair-it-up-cta').on('mouseenter', function () {
    $('.img-zoom-lens').addClass('d-none');
    $('#hover-result-container').addClass('d-none');
});

$(window).on('scroll', function () {
    if (zoomActive) {
        var $productMedia = $('.image-carousel-wrapper');

        var productMediaBottom = $productMedia.offset().top + $productMedia.outerHeight();
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var triggerPoint = scrollTop + (windowHeight * 0.7); // trigger point 70% of viewport

        if (triggerPoint >= productMediaBottom) {
            window.disableZoomDeskProductImage();
        }
    }

    if ($(window).width() > 1250) {
        var visibleHeaderHeight = $('header')[0].getBoundingClientRect().bottom;
        var pdpLeftMedia = $('.product-media')[0];

        var pdpLeftMediaBottom = pdpLeftMedia.getBoundingClientRect().bottom;

        if (pdpLeftMediaBottom <= visibleHeaderHeight) {
            $('.stone-fact-desktop').removeClass('set-position').addClass('d-none');
        }
    }
});
